module.exports = __webpack_public_path__ + "img/gsk.01756814.svg";